(function( root, $, undefined ) {

    $(function () {


        var galleryThumbs = new Swiper('.gallery-thumbs', {
            direction: 'vertical',
            slidesPerView: 4,
            freeMode: true,
            loopedSlides: 4, //looped slides should be the same
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            roundLengths: true
        });
        var galleryTop = new Swiper('.gallery-top', {
            loopedSlides: 4, //looped slides should be the same
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            thumbs: {
                swiper: galleryThumbs,
            },
        });

        //Handle form uploaded images
        function updateUploadedImages () {
            $('.dnd-upload-status').each(function(){
                var imageUrl = '/wp-content/uploads/wpcf7_uploads/' + $(this).find('input[type="hidden"]').val();
                if($(this).find('.dnd-image-placeholder').length < 1 && $(this).find('input[type="hidden"]').length > 0) {
                    $(this).prepend('<div class="dnd-image-placeholder" style="background-image: url('+imageUrl+')"></div>');
                    $(this).addClass('active');
                }
            })
        }
        setInterval(updateUploadedImages, 500);

        // Single Gallery Slider
        var swiperSingleGallery = new Swiper('.gallery-single .swiper-container', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        function refreshBroadcast() {

            $('#broadcast').addClass('broadcast--loading');
            var id = $('#broadcast').data('id');

            $.ajax({
                url: ajaxurl,
                data: {
                    'action' : 'fetch_live_content',
                    'id' : id
                },
                success:function(data) {
                    $('#broadcast .broadcast__feed').html(data);
                    $('#broadcast').removeClass('broadcast--loading');
                }
            });
        }

        // Live Broadcast
        if($('#broadcast').length > 0) {
            refreshBroadcast();
            setInterval(refreshBroadcast, 60000);
        }

        // WCAG Features
        $("html").css('font-size', parseInt(Cookies.get('fontSize')));


        // Map Picker
        if($('#map-picker').length > 0) {
            var map; //Will contain map object.
            var marker = false; ////Has the user plotted their location marker?

            //Function called to initialize / create the map.
            //This is called when the page has loaded.
            function initMapLeszno() {

                //The center location of our map.
                var centerOfMap = new google.maps.LatLng(52.257982,20.591052);

                //Map options.
                var options = {
                    center: centerOfMap, //Set center.
                    zoom: 15 //The zoom value.
                };

                //Create the map object.
                map = new google.maps.Map(document.getElementById('map-picker'), options);

                //Listen for any clicks on the map.
                google.maps.event.addListener(map, 'click', function(event) {
                    //Get the location that the user clicked.
                    var clickedLocation = event.latLng;
                    //If the marker hasn't been added.
                    if(marker === false){
                        //Create the marker.
                        marker = new google.maps.Marker({
                            position: clickedLocation,
                            map: map,
                            draggable: true //make it draggable
                        });
                        //Listen for drag events!
                        google.maps.event.addListener(marker, 'dragend', function(event){
                            markerLocation();
                        });
                    } else{
                        //Marker has already been added, so just change its location.
                        marker.setPosition(clickedLocation);
                    }
                    //Get the marker's location.
                    markerLocation();
                });
            }

            //This function will get the marker's current location and then add the lat/long
            //values to our textfields so that we can save the location.
            function markerLocation(){
                //Get location.
                var currentLocation = marker.getPosition();
                //Add lat and lng values to a field that we can save.
                document.getElementById('intervention_latitude').value = currentLocation.lat(); //latitude
                document.getElementById('intervention_longitude').value = currentLocation.lng(); //longitude
            }


            //Load the map when the page has finished loading.

            google.maps.event.addDomListener(window, 'load', initMapLeszno);

        }



        // WCAG
        var cook = {
            fontSize: 16
        }

        $(".font-increase").click(function (e) {
            e.preventDefault(e);
            cook.fontSize = parseInt($("html").css('font-size'));
            $("html").css('font-size', cook.fontSize + 1);
            cook.fontSize = $("html").css('font-size');

            Cookies.set('fontSize', cook.fontSize, {
                expires: 7,
                path: '/'
            });

        });

        $(".font-decrease").click(function (e) {
            e.preventDefault();
            cook.fontSize = parseInt($("html").css('font-size'));
            if(cook.fontSize == 12) return;
            $("html").css('font-size', cook.fontSize - 1);
            cook.fontSize = $("html").css('font-size');

            Cookies.set('fontSize', cook.fontSize, {
                expires: 7,
                path: '/'
            });

        });

    });

} ( this, jQuery ));
